// The Prime app (docs/prime-app.md): a second home-screen app on the same
// origin, started from /prime (prime.html, its own manifest and icon). iOS keeps
// each home-screen app's storage apart, so it signs in as a device of its own,
// with its own push subscription, and Prime's notifications go to it.
//
// It knows it is the Prime app from its page (prime.html marks <html
// data-app="prime">), and, once installed, remembers it in its own storage, so a
// reload on another path stays the Prime app. A browser tab is only the Prime
// app on /prime itself.

const KEY = 'app-shell'

const standalone = (): boolean => {
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true
    )
  } catch {
    return false
  }
}

const decide = (): boolean => {
  if (typeof document === 'undefined') return false
  const page = document.documentElement.dataset.app === 'prime'
  if (!standalone()) return page
  try {
    if (page) localStorage.setItem(KEY, 'prime')
    return page || localStorage.getItem(KEY) === 'prime'
  } catch {
    return page
  }
}

/** Whether this is the Prime app, decided once at start. */
export const PRIME_APP = decide()
